import PauseIcon from "@mui/icons-material/Pause";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  IconButton,
  Slider,
  Stack,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Loader from "../../../../common/Loader";
import { useSelector } from "react-redux";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";

function VideoViewer({ file, showDetails }) {
  const [isPaused, setIsPaused] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const videoRef = useRef(null);
  const { multiLanguageData } = useSelector((state) => state?.main);
  const [showLoader, setShowLoader] = useState(true);
  const LANGUAGE = ClientEnglishFallback.VideoViewer(multiLanguageData?.VideoViewer || {})
  const {
    TEXT_YOUR_BROWSER_DOES_NOT_SUPPORT_THE_VIDEO_TAG
  } = LANGUAGE;
  const handlePausePlay = () => {
    try {
      const video = videoRef?.current;
      if (video?.paused) {
        video?.play();
        setIsPaused(false);
      } else {
        video?.pause();
        setIsPaused(true);
        setCurrentTime(video.currentTime); // Update currentTime immediately
      }
    } catch (error) {
      console.log('handlePausePlay-> Error In Handling Pause Play: ',error);
    }
  };

  const onLoadedMetadata = () => {
    setShowLoader(false);
    const video = videoRef?.current;
    if (video) {
      setDuration(video.duration); // Set the video duration once metadata is loaded
    }
  };

  useEffect(() => {
    const video = videoRef?.current;
    const updateCurrentTime = () => {
      if (!video?.paused) {
        setCurrentTime(video.currentTime); // Update currentTime only when video is playing
      }
    };

    // Add timeupdate event listener to update currentTime
    video?.addEventListener("timeupdate", updateCurrentTime);

    return () => {
      // Cleanup on unmount
      video?.removeEventListener("timeupdate", updateCurrentTime);
    };
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <Box>
      <Box width={"100%"}>
        <div style={{ height: "100%", position: "relative" }}>
          <video
            autoPlay
            style={{
              height: "auto",
              maxHeight: " 60vh",
              minWidth: "90%",
              width: "100%",
              objectFit: "contain",
            }}
            onClick={handlePausePlay}
            ref={videoRef}
            onLoadedMetadata={onLoadedMetadata}
          >
            <source src={file?.fileUrl} type="video/mp4" />
            {TEXT_YOUR_BROWSER_DOES_NOT_SUPPORT_THE_VIDEO_TAG}
          </video>
          {showLoader && (
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontSize: "4rem",
              }}
            >
              <Loader />
            </div>
          )}

          {isPaused && !showLoader && (
            <IconButton
              onClick={handlePausePlay}
              variant="h1"
              component="div"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                color: "white",
                fontSize: "4rem",
              }}
            >
              <PauseIcon fontSize="1rem" />
            </IconButton>
          )}
          <div
            style={{
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "20px",
            }}
          >
            <Typography sx={{ color: "black" }}>{formatTime(currentTime)}</Typography>
            <Slider
              value={
                currentTime >= duration - 0.5
                  ? 100
                  : (currentTime / duration) * 100
              }
              min={0}
              step={0.1}
              max={100}
              sx={{
                width: "100%",
                color: "red",
                "& .MuiSlider-thumb": {
                  backgroundColor: "red",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "white",
                },
                "& .MuiSlider-track": {
                  backgroundColor: "red",
                },
              }}
            />
            <Typography sx={{ color: "black" }}>{formatTime(duration)}</Typography>
          </div>
        </div>
      </Box>
      {showDetails && (
        <Stack sx={{ mt: 0.5, wordSpacing: 1,
            lineHeight: "0.9rem",
            overflow: "scroll",
            scrollbarWidth: "none", }} onClick={(e) => { }}
        >
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"} className="other-stack-adjust">
            <Stack direction={"row"}  sx={{ gap: 1, alignItems: "center" }}>
              <Avatar alt="Remy Sharp" src={file?.userProfilePicture} />
              <Typography>{file?.userName}</Typography>
            </Stack>
            <Typography>
              {moment(file?.dateCreated).format("MMMM DD, YYYY")}
            </Typography>
          </Stack>
          <Typography
            maxHeight={"100px"}
            overflow={"scroll"}
            variant="body2"
            sx={{ mt: 1 }}
          >
            {file?.description}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}

export default VideoViewer;
